import { render, staticRenderFns } from "./Overflow.vue?vue&type=template&id=4e4f696c&"
import script from "./Overflow.vue?vue&type=script&lang=js&"
export * from "./Overflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports